module.exports = __webpack_public_path__ + "img/20190830145854360截图20190830132440281.08ec626b.jpg";